module.exports = __webpack_public_path__ + "static/chrisliebing_1-7556244597ea5b32a4c68fe48da29674.jpg";